import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'

const styles = () => ({
  group: {
    display: 'inline-flex',
    border: '1px solid var(--careco-border)',
    borderRadius: 'var(--careco-rounded-md, 12px)',
    overflow: 'hidden',
    background: 'var(--careco-surface)',
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '7px',
    border: 'none',
    background: 'transparent',
    padding: '9px 14px',
    cursor: 'pointer',
    fontFamily: 'var(--careco-font)',
    fontSize: 13,
    fontWeight: 600,
    color: 'var(--careco-text-secondary)',
    transition: 'background 120ms ease, color 120ms ease',
    '&:hover': { background: 'var(--careco-row-default)', color: 'var(--careco-text-primary)' },
    '&:focus-visible': {
      outline: '2px solid var(--careco-primary)',
      outlineOffset: -2,
    },
  },
  active: {
    background: 'var(--careco-primary-light)',
    color: 'var(--careco-primary)',
    '&:hover': { background: 'var(--careco-primary-light)', color: 'var(--careco-primary)' },
  },
  glyph: {
    fontSize: 13,
    lineHeight: 1,
  },
})

export const VIEW = { TABLE: 'table', GRID: 'grid' }

const ViewToggle = ({ classes, value, onChange }) => {
  const option = (view, glyph, label) => (
    <button
      type="button"
      className={`${classes.button} ${value === view ? classes.active : ''}`}
      aria-pressed={value === view}
      onClick={() => onChange(view)}>
      <span className={classes.glyph} aria-hidden="true">
        {glyph}
      </span>
      {label}
    </button>
  )

  return (
    <div className={classes.group} role="group" aria-label="List layout">
      {option(VIEW.GRID, '▦', 'Grid')}
      {option(VIEW.TABLE, '☰', 'Table')}
    </div>
  )
}

ViewToggle.propTypes = {
  classes: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export default withStyles(styles)(ViewToggle)
